module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-01-m.1a3de744031c755e9f68a34fdda8273b.png";